import './CatalogPage.scss'

import React, { useState, useEffect, useRef } from 'react'

import { Link } from 'react-router-dom'

import {
  MoreVertical,
  Pencil,
  Trash2,
} from 'lucide-react'

import {
  DotsThreeVertical,
  MagnifyingGlass,
  ArrowsClockwise,
} from '@phosphor-icons/react'

const categories = [
  'All (24)',
  'Mains (24)',
  'Drinks (24)',
  'Sides (24)',
  'Desserts (24)',
  'Unavailable (24)',
]

const products = [
  {
    id: 1,
    name: 'Miso Ramen Noodles',
    price: 'RM20.90',
    oldPrice: 'RM23.90',
    category: 'Ramen',
    image:
      'https://images.unsplash.com/photo-1614563637806-1d0e645e0940?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 2,
    name: 'Chicken Katsu Curry Don',
    price: 'RM22.90',
    category: 'Rice',
    image:
      'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 3,
    name: 'Salmon Mentai Mini Don',
    price: 'RM22.90',
    oldPrice: 'RM28.90',
    category: 'Rice',
    image:
      'https://images.unsplash.com/photo-1611143669185-af224c5e3252?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 4,
    name: 'Chicken Teriyaki',
    price: 'RM22.90',
    category: 'Main',
    image:
      'https://images.unsplash.com/photo-1559847844-d721426d6edc?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 5,
    name: 'Salmon Mentai Mini Don',
    price: 'RM22.90',
    category: 'Sides',
    image:
      'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 6,
    name: 'Salmon Mentai Mini Don',
    price: 'RM22.90',
    category: 'Sides',
    image:
      'https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 7,
    name: 'Tonkotsu Ramen',
    price: 'RM22.90',
    oldPrice: 'RM28.90',
    category: 'Sides',
    image:
      'https://images.unsplash.com/photo-1557872943-16a5ac26437e?q=80&w=1200&auto=format&fit=crop',
    active: true,
  },
  {
    id: 8,
    name: 'Unagi Don',
    price: 'RM32.90',
    category: 'Sides',
    image:
      'https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?q=80&w=1200&auto=format&fit=crop',
    active: false,
  },
]

export default function CatalogPage() {

  const [openMenuId, setOpenMenuId] = useState(null)

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMenuId(null)
    }

    document.addEventListener(
      'click',
      handleClickOutside
    )

    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside
      )
    }
  }, [])

  return (
    <div className="catalog-page">
      {/* HEADER */}

      <div className="catalog-header">
        <div>
          <div className="catalog-header__breadcrumb">
            Hikaya House / Catalog
          </div>

          <h1 className="catalog-header__title">
            Catalog management
          </h1>

          <p className="catalog-header__description">
            Manage menu items synced from POS.
            Toggle availability and add new
            products.
          </p>
        </div>

        <div className="catalog-header__actions">
          <div className="catalog-search">
            <MagnifyingGlass size={18} />

            <input
              type="text"
              placeholder="Search products"
            />
          </div>

          <button className="catalog-sync">
            <ArrowsClockwise size={18} />
            Sync POS
          </button>
        </div>
      </div>

      {/* TABS */}

      <div className="catalog-tabs">
        {categories.map((category, index) => (
          <button
            key={category}
            className={`catalog-tabs__item ${
              index === 0 ? 'active' : ''
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* GRID */}

      <div className="catalog-grid">
        {products.map((product) => (
          <div
            className="catalog-card"
            key={product.id}
          >
            <div className="catalog-card__image-wrapper">
              <img
                src={product.image}
                alt={product.name}
                className="catalog-card__image"
              />
            </div>

            <div className="catalog-card__body">
              <div className="catalog-card__top">
                <div>
                  <h3 className="catalog-card__title">
                    {product.name}
                  </h3>

                  <div className="catalog-card__price">
                    {product.oldPrice && (
                      <span className="catalog-card__old-price">
                        {product.oldPrice}
                      </span>
                    )}

                    <span>{product.price}</span>
                  </div>
                </div>

                <div
                  className="catalog-card__menu"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="catalog-card__menu-trigger"
                    onClick={() =>
                      setOpenMenuId(
                        openMenuId === product.id
                          ? null
                          : product.id
                      )
                    }
                  >
                    <MoreVertical size={18} />
                  </button>

                  {openMenuId === product.id && (
                  <div className="catalog-card__dropdown">
                    <Link
                      to={`/products/${product.id}/edit`}
                      className="catalog-card__dropdown-item"
                    >
                      <Pencil size={16} />
                      Edit
                    </Link>
                  </div>
                  )}
                </div>
              </div>

              <div className="catalog-card__footer">
{/*                <label className="catalog-switch">
                  <input
                    type="checkbox"
                    disabled
                    defaultChecked={
                      product.active
                    }
                  />

                  <span className="catalog-switch__slider" />
                </label>*/}
                <div
                  className={`catalog-card__status ${
                    product.active
                      ? 'catalog-card__status--enabled'
                      : 'catalog-card__status--disabled'
                  }`}
                >
                  {product.active
                    ? 'Enabled'
                    : 'Disabled from POS'}
                </div>
                <span className="catalog-card__tag">
                  {product.category}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* PAGINATION */}

      <div className="catalog-pagination">
        <div className="catalog-pagination__results">
          Showing 1-10 of 79 results
        </div>

        <div className="catalog-pagination__pages">
          <button className="active">
            1
          </button>

          <button>2</button>
          <button>3</button>
          <button>4</button>
          <button>5</button>

          <span>...</span>

          <button>8</button>
        </div>
      </div>
    </div>
  )
}